import VueKonva from "vue-konva"

export default definePlugin((app) => {
    app.use(VueKonva)
})
